<template>
  <el-container>
    <el-header class="el-header-main sticky-top">
      <SuperadminMainMenu v-if="userStore.type === 'super'"></SuperadminMainMenu>
      <ProductLoaderMainMenu v-if="userStore.type === 'product-loader'"></ProductLoaderMainMenu>
      <mainMenu v-if="['agency', 'adviser'].includes(userStore.type)" />
    </el-header>
    <el-main :class="$route.name">
      <RouterView
        :mode="$route.meta.mode" 
        />
    </el-main>
    <SuperadminDrawer v-if="userStore.type === 'super'"></SuperadminDrawer>
    <ProductLoaderDrawerComponent v-if="userStore.type === 'product-loader'"></ProductLoaderDrawerComponent>
    <DrawerComponent v-if="['agency', 'adviser'].includes(userStore.type)"></DrawerComponent>
  </el-container>
</template>

<script setup>
import { RouterView } from 'vue-router'
import mainMenu from '@/components/navigation/mainMenu.vue'
import DrawerComponent from '@/components/navigation/DrawerComponent.vue'
import SuperadminMainMenu from '@/components/navigation/SuperadminMainMenu.vue'
import SuperadminDrawer from '@/components/navigation/SuperadminDrawer.vue'
import ProductLoaderMainMenu from '@/components/navigation/product-loader/MainMenu.vue'
import ProductLoaderDrawerComponent from '@/components/navigation/product-loader/DrawerComponent.vue'

import { useUserStore } from '@/stores/user'
const userStore = useUserStore()

</script>

<style>
.el-main {
  min-height: 90vh;
}
.el-header-main {
  background-color: #fff;
}
</style>
